import { createContext, useContext } from 'react'
import { Can as CaslCan } from '@casl/react'

// CASL v7 dropped `createContextualCan` and `AbilityContext`.
// We keep a local context so the rest of the app keeps using the same API
// (`useContext(AbilityContext)`, `<AbilityContext.Provider value={ability}>`).
export const AbilityContext = createContext(null)

// <Can /> reads the ability from our local context and forwards to CASL's <Can />.
export const Can = (props) => {
  const ability = useContext(AbilityContext)
  return <CaslCan {...props} ability={ability} />
}
